/*=========================================================================================
  File Name: translationsActions.js
  Description: Vuex Store - translations actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getTranslations({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/all-translations', method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    updateTranslation({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/translation/update', data: payload, method: 'POST'})
                .then(({data}) => {
                    payload.notify({
                        time: 3500,
                        text: state.currentTranslations[data.message],
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    });

                    if (state.activeLanguage.locale === data.lang) {
                        commit('update_translation_success', data);

                        if (data.translation.model === 'App\\Models\\Backend\\MenuItemPermission') {

                            axios({url: state.API_URL + '/auth/backend-menus', method: 'GET'}).then(nav => {
                                let nav_data = {
                                    menus: {
                                        sidebarMenuAdminName: nav.data.sidebarMenuAdminName,
                                        sidebarMenuAdmin: nav.data.sidebarMenuAdmin,
                                        profileMenu: nav.data.profileMenu,
                                    },
                                    searchable: nav.data.searchable,
                                    staredPages: nav.data.staredPages,
                                };
                                commit('update_translation_menu_success', nav_data);
                            })
                        }
                    }

                    resolve();
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
